export const resources = {
  FacePileProfilePictureLabel: '',
  FacePileProfilePictureTitle: '',
  ShowMore: 'ShowMore',
  PeopleShowingPersonProfile: ''
};
